import axios from 'axios';
import { BaseTransport } from 'common/dto/base.transport';
import { IMarkAsReadParams, IMessageCollection, IMessageCreateParams, IMessageModel } from 'entities/Messages/Messages.models';

export class MessagesTransport extends BaseTransport<IMessageModel, IMessageCollection, IMessageCreateParams> {
  public markAsRead = (params: IMarkAsReadParams) => {
    return axios.put(`${this.path}/multiple-read`, params);
  };
}
